<app-admin-form [title]="'Leveranciers Documenten'" [object]="supplierInterfaceData">
  <ng-template #dropdownTemplate let-model='model'>
    <span *ngIf="model; else noneSelected">{{model?.Name}}</span>
    <ng-template #noneSelected>niets gekozen</ng-template>
  </ng-template>
  <app-admin-custom-control [label]="'Soort koppeling'">
    <div class="row gy-2 gx-3 align-items-center">
      <div class="col-auto">
        <app-admin-dropdown [(model)]="request.DocumentKind" [modelValues]="[0,1]"
          [modelDisplayValues]="{'0':'Pakbonnen','1':'Facturen'}" [modelEmptyDisplayValue]="'Kies een documentsoort...'"
          (modelChange)="setInterfaceKinds(request.DocumentKind)" [dividerKind]="-1">
        </app-admin-dropdown>
      </div>
      @if (interfaceKinds) {
      <div class="col-auto">
        <app-admin-dropdown [(model)]="interfaceKindInfo" [modelValues]="interfaceKinds" [modelDisplayProperty]="'Name'"
          [modelEmptyDisplayValue]="'Kies een koppeling...'"
          (modelChange)="setInterfaceData(interfaceKindInfo.InterfaceKind)" [dividerKind]="-1">
        </app-admin-dropdown>
      </div>
      }

    </div>
  </app-admin-custom-control>
  <app-admin-custom-control [label]="'Datum vanaf en tot'">
    <div class="row">
      <div class="col-md-6"><app-admin-date-input [labelCols]="0" [dividerKind]="-1"
          [(model)]="request.DocumentFromDate" [withTimepicker]="true"></app-admin-date-input></div>
      <div class="col-md-6"><app-admin-date-input [labelCols]="0" [dividerKind]="-1" [(model)]="request.DocumentToDate"
          [withTimepicker]="true"></app-admin-date-input></div>
    </div>
  </app-admin-custom-control>



  <app-admin-action-button (clickAction)="supplierGetInterfaceDocuments()" [buttonColor]="'info'"
    [disabled]="!request.InterfaceData" [dividerKind]="(response || busy)?0:-1">
    <span *ngIf="busy"><i class="fas fa-sync fa-spin"></i></span><span *ngIf="!busy"><i
        class="fas fa-info-circle"></i></span>
    @if (request.DocumentKind==0) {
    Pakbonnen
    } @else {
    Facturen
    }
    ophalen
  </app-admin-action-button>

  <app-admin-custom-control *ngIf="response || busy" [label]="'Info'" [busy]="busy" [dividerKind]="-1"
    (contextmenu)="mainService.showDebugInfo($event, response?.Timing,response?.Documents)">
    <ng-container *ngIf="response" afterLabel>
      <br />
      <button type="button" class="btn btn-light me-2" (click)="mainService.showTimingDialog(response.Timing)"><i
          class="far fa-stopwatch"></i></button>
    </ng-container>
    <table class="table table-striped table-sm small">
      <thead>
        <tr>
          <th>Filiaal</th>
          <th>Klantcode</th>
          <th>Document ID</th>
          <th>Status</th>
          <th>Timestamp</th>
          <th>Document</th>
        </tr>
      </thead>
      <tbody>
        @for (document of response?.Documents; track document; let i = $index) {
        <tr>
          <td>{{branches[document.CustomerBranch].BranchNameShort}}</td>
          <td>{{document.CustomerCode}}</td>
          <td>{{document.DocumentId}}</td>
          <td [ngClass]="{'text-danger': document.DocumentStatus==-999}">{{getStatusString(document.DocumentStatus)}}</td>
          <td>
            {{document.DocumentTimestamp | date : 'dd-MM-yyyy HH:mm' }}
            <!-- {{document.Created | date : 'dd-MM-yyyy HH:mm' }}
            {{document.Updated | date : 'dd-MM-yyyy HH:mm' }} -->
          </td>
          <td>
            <button *ngIf="document.DocumentContent" type="button"
              class="btn btn-warning btn-xs w-100 text-start d-flex justify-content-between align-items-center"
              (click)="mainService.showObjectDialog($event, document.DocumentContent)">
              <span>
                <i class="far fa-file"></i>
                <span class="ms-2">{{ document.FileName }}</span>
              </span>
              <span class="text-end text-muted small">
                {{ stringSizeInKB(document.DocumentContent).toFixed(1) }} kB
              </span>
            </button>

          </td>
        </tr>
        }
      </tbody>
    </table>
  </app-admin-custom-control>


</app-admin-form>